import { uniqBy } from 'lodash'

export const boldKeyWords = (keyword, text = '') =>
  text.replace(new RegExp('(' + keyword + ')', 'ig'), '<b>$1</b>')

export const filterDuplicateMessages = (hits) => {
  return uniqBy(hits, (hit) => hit.hit.slug_with_series)
}
